<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-if="theUserProject==0" v-model='theProjectId' @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-button
          v-click.getDataOnlineUserList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable ref="getDataOnlineUserList"
      :tableColums='tableColums_getDataOnlineUserList'
      api='getDataOnlineUserList'
      xupdateapi='updateUser'
      :height="H-165" >
    </mytable> 
    
    <myform view.getDataUserDetails='用户详情'
      @opened='arguments[0].title += " | @" + row.userName'>
      <div v-if='dataUserDetailsAll'>
        <!-- <div>姓名 :  {{dataUserDetails.userName}}</div>
        <div>岗位名称 : {{dataUserDetails.postId}}</div> -->
        <el-avatar size="small" :src="dataUserDetails.userHeader"></el-avatar>
        <div>用户项目 :  </div>
        <el-card v-for="item in dataUserProjectDetails" :key="item.puId" >
          项目名称 : {{item.projectName}}
          加入时间 : {{item.createtime}}
          <div>所属战队 ：{{item.dtName}}</div>
          <div>目标走访数量 ：{{item.userVisitorTargetCount}}</div>
          <div>目标签单金额 ：{{item.userOrderMoneyTarget}}</div>
        </el-card>
      </div>
      <hide slot='userId' />
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userId: null,
      row:{},
      dataUserDetailsAll:{},
      dataUserDetails:{},
      dataUserProjectDetails:{},
      theProjectId:"",
      theUserProject:"",
      tableColums_getDataOnlineUserList: {
        $selection: false,
        userName: '用户名',
        userPhone: '手机号',
        postId: [ '岗位', , '@v-if: 1:平台管理, 2:战队管理, 3:项目经理, 4:老师, 5:学员, 6:项目管理员' ],
        yutName:'类型',
        loginLastTime: '最后活跃时间',
        $operation: [
          '操作', 200,
          this.getDataUserDetails && `@text: 详情#success
           @click: toGetDataUserDetails($row)
          `,

        ],
      },

    };
  },

  watch: {
    
  },

  methods: {
    toGetDataUserDetails(row){
      this.$form("getDataUserDetails", this.row = row)
      this.getDataUserDetails({userId:row.userId}).result(res=>{
        this.dataUserDetailsAll=res;
        this.dataUserDetails=res.data.data.user;
        this.dataUserProjectDetails=res.data.data.projectUserList;
      })
    },
    theProjectAllChange(e){
      this.theProjectId=e;
      this.getData();
    },
    getData(){
        if(this.theProjectId==0){
            this.theProjectId=null;
        }
        this.getDataOnlineUserList({projectId:this.theProjectId});
    }
  },

  created() {
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject==0){
      this.getProjectList({pageSize:0});
    }else{
      this.theProjectId=this.theUserProject;
    }
    this.getData();
  },
  mounted(){
    
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/data/DataOnlineUser.vue